import { useEffect } from "react";

export function useContentProtection() {
  useEffect(() => {
    const prevent = (e: Event) => e.preventDefault();

    // Block copy, cut, selectstart, contextmenu, dragstart
    document.addEventListener("copy", prevent);
    document.addEventListener("cut", prevent);
    document.addEventListener("selectstart", prevent);
    document.addEventListener("contextmenu", prevent);
    document.addEventListener("dragstart", prevent);

    // Block keyboard shortcuts
    const onKeyDown = (e: KeyboardEvent) => {
      const ctrl = e.ctrlKey || e.metaKey;
      // Block Ctrl+C, Ctrl+U, Ctrl+S, Ctrl+P, Ctrl+A
      if (ctrl && ["c", "u", "s", "p", "a"].includes(e.key.toLowerCase())) {
        e.preventDefault();
      }
      // Block PrintScreen
      if (e.key === "PrintScreen") {
        e.preventDefault();
      }
      // Block F12 (DevTools)
      if (e.key === "F12") {
        e.preventDefault();
      }
      // Block Ctrl+Shift+I (DevTools)
      if (ctrl && e.shiftKey && e.key.toLowerCase() === "i") {
        e.preventDefault();
      }
    };
    document.addEventListener("keydown", onKeyDown);

    return () => {
      document.removeEventListener("copy", prevent);
      document.removeEventListener("cut", prevent);
      document.removeEventListener("selectstart", prevent);
      document.removeEventListener("contextmenu", prevent);
      document.removeEventListener("dragstart", prevent);
      document.removeEventListener("keydown", onKeyDown);
    };
  }, []);
}
